import { CSSProperties } from '@material-ui/styles';
import { adminPagesSharedStyles, BORDER, MUTED, NAVY, TEXT } from '../style';

const nativeDatePickerIndicator = {
  display: 'none',
  appearance: 'none',
  WebkitAppearance: 'none',
  opacity: 0,
  width: 0,
  height: 0,
  margin: 0,
  padding: 0,
  border: 0,
  background: 'transparent',
  backgroundImage: 'none',
  color: 'transparent',
  pointerEvents: 'none',
  position: 'absolute',
} as CSSProperties;

export const datePickerFieldStyles: {
  textField: CSSProperties;
  datePickerBtn: CSSProperties;
} = {
  textField: {
    '& input[type="date"]': {
      cursor: 'text',
      appearance: 'none',
      WebkitAppearance: 'none',
      MozAppearance: 'none',
      position: 'relative',
    },
    '& input[type="date"]::-webkit-calendar-picker-indicator': nativeDatePickerIndicator,
    '& input[type="date"]::-moz-calendar-picker-indicator': nativeDatePickerIndicator,
    '& input[type="date"]::-webkit-inner-spin-button': nativeDatePickerIndicator,
    '& input[type="date"]::-webkit-clear-button': nativeDatePickerIndicator,
    '& input[type="date"]::-webkit-datetime-edit': {
      display: 'inline-flex',
      padding: 0,
    },
    '& input[type="date"]::-webkit-date-and-time-value': {
      textAlign: 'left',
      minHeight: '1.2em',
    },
  },
  datePickerBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 0,
    padding: 0,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    lineHeight: 0,
    position: 'relative',
    zIndex: 1,
  },
};

export const consultantSharedStyles: {
  fullField: CSSProperties;
  footer: CSSProperties;
  footerEnd: CSSProperties;
  warningBox: CSSProperties;
  warningTitle: CSSProperties;
  userCard: CSSProperties;
  avatar: CSSProperties;
  userMeta: CSSProperties;
  userName: CSSProperties;
  userRole: CSSProperties;
  viewProfileBtn: CSSProperties;
  chips: CSSProperties;
  editForm: CSSProperties;
  editFormBody: CSSProperties;
  fieldError: CSSProperties;
  formFooter: CSSProperties;
  saveBtn: CSSProperties;
} = {
  fullField: {
    width: '100%',
  },
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: 40,
    paddingTop: 8,
  },
  footerEnd: {
    justifyContent: 'flex-end',
  },
  warningBox: {
    marginTop: 16,
    padding: 16,
    borderRadius: 10,
    background: '#F3F4F8',
  },
  warningTitle: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    fontFamily: 'Poppins',
    fontSize: 14,
    color: TEXT,
    marginBottom: 12,
    '& span': {
      fontFamily: 'Poppins',
    },
  },
  userCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    background: '#FFFFFF',
    borderRadius: 10,
    padding: '12px 14px',
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    objectFit: 'cover',
    background: NAVY,
    color: '#FFFFFF',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 16,
    flexShrink: 0,
  },
  userMeta: {
    flex: 1,
    minWidth: 0,
  },
  userName: {
    fontFamily: 'Poppins',
    fontSize: 15,
    fontWeight: 700,
    color: TEXT,
    margin: 0,
  },
  userRole: {
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 400,
    color: TEXT,
    marginTop: 2,
  },
  viewProfileBtn: {
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 600,
    fontSize: 13,
    color: TEXT,
    border: `1.5px solid ${BORDER}`,
    borderRadius: 8,
    background: '#FFFFFF',
    whiteSpace: 'nowrap',
    padding: '8px 12px',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
  },
  editForm: {
    width: '100%',
  },
  editFormBody: {
    maxWidth: 640,
  },
  fieldError: {
    fontFamily: 'Poppins',
    fontSize: 13,
    color: '#D32F2F',
    marginTop: 6,
  },
  formFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: 12,
    marginTop: 40,
    paddingTop: 8,
  },
  saveBtn: {
    background: '#000A8D',
    color: '#FFFFFF',
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 15,
    borderRadius: 8,
    padding: '10px 20px',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
    '&:disabled': {
      background: '#E8EAF0',
      color: MUTED,
      '& svg path': {
        fill: 'grey',
      },
    },
    '& svg path': {
      fill: '#FFFFFF',
    },
  },
};

export const profileSharedStyles: {
  titleRow: CSSProperties;
  title: CSSProperties;
  editPageTitle: CSSProperties;
  statusTag: CSSProperties;
  statusActive: CSSProperties;
  statusInactive: CSSProperties;
  tabs: CSSProperties;
  tab: CSSProperties;
  tabActive: CSSProperties;
  card: CSSProperties;
  editBtn: CSSProperties;
  fields: CSSProperties;
  fieldRow: CSSProperties;
  fieldLabel: CSSProperties;
  fieldValue: CSSProperties;
  missing: CSSProperties;
  actions: CSSProperties;
  actionBtn: CSSProperties;
  tableWrap: CSSProperties;
  table: CSSProperties;
  thLeft: CSSProperties;
  thCenter: CSSProperties;
  thRight: CSSProperties;
  prestationBadge: CSSProperties;
  actionsCell: CSSProperties;
  iconBtn: CSSProperties;
  emptyCell: CSSProperties;
  addPrestationBtn: CSSProperties;
  sectionTitle: CSSProperties;
} = {
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 20,
    flexWrap: 'wrap',
  },
  title: {
    ...adminPagesSharedStyles.title,
    color: '#000B33',
  },
  editPageTitle: {
    ...adminPagesSharedStyles.title,
    margin: '0 0 32px',
  },
  statusTag: {
    display: 'inline-flex',
    alignItems: 'center',
    borderRadius: 6,
    padding: '4px 10px',
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 600,
  },
  statusActive: {
    background: '#D8F0C8',
    color: '#3F6B1D',
  },
  statusInactive: {
    background: '#E8EAF0',
    color: '#5A607F',
  },
  tabs: {
    display: 'flex',
    gap: 28,
    borderBottom: `1px solid ${BORDER}`,
    marginBottom: 24,
  },
  tab: {
    padding: '12px 0',
    border: 'none',
    background: 'transparent',
    fontFamily: 'Poppins',
    fontSize: 15,
    fontWeight: 400,
    color: '#000B33',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    borderBottom: '3px solid transparent',
    marginBottom: -1,
  },
  tabActive: {
    fontWeight: 500,
    borderBottomColor: NAVY,
  },
  card: {
    position: 'relative',
    background: '#FFFFFF',
    borderRadius: 12,
    border: `1px solid ${BORDER}`,
    padding: '32px 36px',
    '@media (max-width: 600px)': {
      padding: '20px 16px',
    },
  },
  editBtn: {
    position: 'absolute',
    top: 24,
    right: 24,
    background: '#FFFFFF',
    color: TEXT,
    border: `1.5px solid ${BORDER}`,
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 14,
    borderRadius: 8,
    padding: '8px 14px',
    boxShadow: 'none',
    '&:hover': {
      background: '#F7F8FB',
      boxShadow: 'none',
    },
    '@media (max-width: 600px)': {
      position: 'static',
      marginBottom: 16,
    },
  },
  fields: {
    maxWidth: 520,
  },
  fieldRow: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 8,
    marginBottom: 14,
    fontFamily: 'Poppins',
    fontSize: 15,
    color: TEXT,
    lineHeight: 1.5,
  },
  fieldLabel: {
    fontWeight: 600,
    whiteSpace: 'nowrap',
    fontFamily: 'Poppins',
  },
  fieldValue: {
    fontWeight: 400,
    fontFamily: 'Poppins',
  },
  missing: {
    color: '#D32F2F',
    fontWeight: 500,
  },
  actions: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 12,
    marginTop: 24,
  },
  actionBtn: {
    background: '#FFFFFF',
    color: TEXT,
    border: `1.5px solid ${BORDER}`,
    textTransform: 'none',
    fontFamily: 'Poppins',
    fontWeight: 500,
    fontSize: 14,
    borderRadius: 8,
    padding: '10px 16px',
    boxShadow: 'none',
    '&:hover': {
      background: '#F7F8FB',
      boxShadow: 'none',
    },
  },
  tableWrap: {
    background: '#FFFFFF',
    borderRadius: 12,
    overflow: 'hidden',
    border: `1px solid ${BORDER}`,
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    '& th': {
      background: NAVY,
      color: '#FFFFFF',
      fontFamily: 'Poppins',
      fontSize: 13,
      fontWeight: 700,
      letterSpacing: '0.04em',
      textTransform: 'uppercase',
      padding: '16px 24px',
      whiteSpace: 'nowrap',
    },
    '& td': {
      padding: '18px 24px',
      borderBottom: '1px solid #EEF0F5',
      fontFamily: 'Poppins',
      fontSize: 15,
      color: TEXT,
      background: '#FFFFFF',
    },
    '& tbody tr:last-child td': {
      borderBottom: 'none',
    },
  },
  thLeft: {
    textAlign: 'left',
  },
  thCenter: {
    textAlign: 'center',
  },
  thRight: {
    textAlign: 'right',
  },
  prestationBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    padding: '6px 14px',
    fontFamily: 'Poppins',
    fontSize: 13,
    fontWeight: 500,
    lineHeight: 1.3,
    whiteSpace: 'nowrap',
  },
  actionsCell: {
    textAlign: 'right',
    whiteSpace: 'nowrap',
  },
  iconBtn: {
    padding: 6,
    color: NAVY,
    '&:hover': {
      background: '#F7F8FB',
    },
    '& svg': {
      display: 'block',
    },
  },
  emptyCell: {
    textAlign: 'center',
    color: MUTED,
    fontFamily: 'Poppins',
    fontSize: 14,
    padding: '28px 24px !important',
  },
  addPrestationBtn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginTop: 16,
    padding: '16px 20px',
    background: '#FFFFFF',
    border: `1.5px solid ${BORDER}`,
    borderRadius: 10,
    fontFamily: 'Poppins',
    fontSize: 15,
    fontWeight: 500,
    color: TEXT,
    cursor: 'pointer',
    '& span': {
      textDecoration: 'underline',
      marginLeft: 4,
    },
    '&:hover': {
      background: '#F7F8FB',
    },
  },
  sectionTitle: {
    ...adminPagesSharedStyles.sectionTitle,
    margin: '0 0 24px',
  },
};
